/** @format */

import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { IHomrBanner } from '@shared/data-access/interfaces';
import { MediaModule } from '@shared/media/components';

@Component({
	selector: 'pdp-homr-banner',
	templateUrl: './homr-banner.component.html',
	imports: [CommonModule, MediaModule],
	styleUrl: './homr-banner.component.scss'
})
export class HomrBannerComponent {
	@Input() data: IHomrBanner;
}
